import { useForm } from "react-hook-form";
import { useTranslation } from "react-i18next";
import GridItemContainer from '../../componentes/form-grids/GridItemContainer';
import GridInputRow from '../../componentes/form-grids/GridInputRow';
import { Grid, IconButton, Tooltip, Typography } from '@material-ui/core';
import { DefaultScreenAccordion } from "../../componentes/layouts/components/DefaultScreenAccordion";
import { useState } from "react";
import { ImageUploadCard } from "../../componentes/DragNDrop/ImageUploadCard";
import { FaInfoCircle } from "react-icons/fa";
import service from "./ProductImportService";
import CustomAlert from "../../componentes/alerts/CustomAlert";
import { DefaultAutocomplete } from "../../componentes/autocomplete/DefaultAutocomplete";
import { IconLabelSwitch } from "../../componentes/iconSwitch/IconLabelSwitch";
import * as XLSX from "xlsx";
import { useRef } from "react";

function convertXlsxToCsv(file) {
    return new Promise((resolve, reject) => {
        console.log("entrou convertXlsxToCsv");
        const reader = new FileReader();

        reader.onload = (e) => {
            const data = new Uint8Array(e.target.result);
            const workbook = XLSX.read(data, { type: "array" });

            const worksheet = workbook.Sheets[workbook.SheetNames[0]];
            const csv = XLSX.utils.sheet_to_csv(worksheet, { FS: ";" });

            resolve(csv);
        };

        reader.onerror = reject;
        reader.readAsArrayBuffer(file);
    });
}

export default function ProductImport() {
    const loggedIdClient = Number(sessionStorage.getItem("idClient") || 0);
    const initialState = {
        idClient: loggedIdClient !== 0 ? loggedIdClient : 0,
        success: false,
        error: false,
        message: ""
    }
    const { t } = useTranslation();
    const userId = sessionStorage.getItem("userId");
    const [state, setState] = useState(initialState);
    const { success, error, message } = state;
    const endPoint = "FileReader/Upload";
    const [open, setOpen] = useState(false);
    const [productimport, setProductImport] = useState(initialState);
    const [openAlert, setOpenAlert] = useState(false);

    function setSuccess(success, message) {
        setState({ success: success, message: message });
    }


    function setError(error, message) {
        setState({ error: error, message: message });
    }

    const closeAlert = (event, reason) => {
        if (reason === 'clickaway') {
            return;
        }
        setOpen(false);
    }

    const isUploadingRef = useRef(false);
    const getFileSignature = (file) =>
        `${file.name}_${file.size}_${file.lastModified}`;
    const processedUploadsRef = useRef(new Set());


    const uploadCallBack = async (args) => {
        console.log("entrou uploadCallBack");
        const file = args?.file?.rawFile;
        if (!file) return;

        const signature = getFileSignature(file);

        // Se ja processou este arquivo, ignora
        // if (processedUploadsRef.current.has(signature)) {
        //     return;
        // }

        processedUploadsRef.current.add(signature);

        try {
            if (productimport.idClient === 0) {
                setError(true, t("invalidCustomer"));
                return;
            }

            const formData = new FormData();
            formData.append("LoggedUserId", userId);
            formData.append("IdClient", productimport.idClient);

            if (file.name.endsWith(".xlsx")) {
                const csvString = await convertXlsxToCsv(file);
                const blob = new Blob([csvString], { type: "text/csv" });

                formData.append(
                    "file",
                    new File([blob], file.name.replace(".xlsx", ".csv"), {
                        type: "text/csv"
                    })
                );
            } else {
                formData.append("file", file);
            }

            const response = await service.imp(formData);

            if (response.status === 200) {
                setSuccess(false, "");
                setSuccess(true, t("saveSuccess"));
            } else {
                setError(false, "");
                setError(true, t("saveError"));
            }

        } catch (err) {
            const backendMessage = err?.response?.data;
            setError(true, typeof backendMessage === "string" && backendMessage ? backendMessage : t("saveError"));
        }
    };


    const handleChange = (event) => {
        const { name, value } = event.target;
        setProductImport({ ...productimport, [name]: value });
    };

    const handleCloseAlert = () => {
        setProductImport({ ...productimport, success: false, error: false, message: "" });
    };

    return (
        <>
            <DefaultScreenAccordion
                isConsult
                title="productImport"
                fields={
                    <>
                        <GridItemContainer>
                            {/* <Snackbar open={open} autoHideDuration={6000} onClose={closeAlert} anchorOrigin={{ verticalAlign: 'top', horizontalAlign: 'center' }} key={'top' + 'center'}>
                                <Alert onClose={closeAlert} severity="error" sx={{ width: '100%' }}>
                                    {t("extensionNotAllowed")}
                                </Alert>
                            </Snackbar> */}
                            <CustomAlert
                                error={error}
                                success={success}
                                message={message}
                                handleCloseAlert={handleCloseAlert}
                                snackbar
                                autoClose
                            />
                            <GridInputRow>
                                <Grid item xs={12} sm={6} md={3}>
                                    <div style={{
                                        pointerEvents: loggedIdClient !== 0 ? "none" : "auto",
                                        opacity: loggedIdClient !== 0 ? 0.8 : 1
                                    }}>
                                        <DefaultAutocomplete
                                            iconLabelSwitch={
                                                <IconLabelSwitch
                                                    name={loggedIdClient !== 0 ? "unLock" : "user"}
                                                    labelName="client"
                                                />
                                            }
                                            transformData={(data) => data.filter(x => [1, 2, 8].includes(x.id))}
                                            name="idClient"
                                            onChange={loggedIdClient !== 0 ? undefined : handleChange}
                                            disabled={loggedIdClient !== 0}
                                            value={productimport.idClient}
                                            defaultSize
                                            useApi
                                            endpoint='GetClientLessGeneric'
                                            error={error && productimport.idClient === 0}
                                        />
                                    </div>
                                </Grid>
                            </GridInputRow>
                            <GridInputRow>
                                <Grid item xs={6} md={6}>
                                    <Typography variant="subtitle1" style={{ fontWeight: 400, marginBottom: 8 }}>
                                        {t("import")}
                                    </Typography>
                                    <Tooltip
                                        title={
                                            <Typography>
                                                {t("dragFileToUpload")}
                                            </Typography>
                                        }
                                    >
                                        <IconButton style={{ marginLeft: "150px" }}>
                                            <FaInfoCircle color="#29438D" />
                                        </IconButton>
                                    </Tooltip>
                                    <ImageUploadCard
                                        open={(e) => setOpen(e)}
                                        uploadCallBack={uploadCallBack}
                                        cantRemove
                                        isRegister={true}
                                        marginBottom
                                        endPoint={endPoint}
                                    />
                                </Grid>
                            </GridInputRow>
                        </GridItemContainer>
                    </>
                }
            />
        </>
    );
};

